var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadqawarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61617 3.6419C10.6736 1.80296 13.3268 1.80296 14.3841 3.6419L22.4271 17.6296C23.4813 19.463 22.1579 21.7504 20.0431 21.7504H3.95721C1.84242 21.7504 0.519055 19.463 1.57322 17.6296L9.61617 3.6419ZM13.0838 4.38961C12.6032 3.55373 11.3972 3.55372 10.9165 4.38961L2.87358 18.3773C2.39441 19.2107 2.99594 20.2504 3.95721 20.2504H20.0431C21.0044 20.2504 21.6059 19.2107 21.1267 18.3773L13.0838 4.38961Z",
    fill: "#D07200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 8.25043C12.4144 8.25043 12.7502 8.58621 12.7502 9.00043V13.0004C12.7502 13.4146 12.4144 13.7504 12.0002 13.7504C11.5859 13.7504 11.2502 13.4146 11.2502 13.0004V9.00043C11.2502 8.58621 11.5859 8.25043 12.0002 8.25043Z",
    fill: "#D07200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5119 16.4418C12.8198 16.7189 12.8447 17.1932 12.5676 17.501L12.5576 17.5122C12.2805 17.82 11.8063 17.845 11.4984 17.5679C11.1906 17.2908 11.1656 16.8166 11.4427 16.5087L11.4527 16.4976C11.7298 16.1897 12.204 16.1648 12.5119 16.4418Z",
    fill: "#D07200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadqawarning);
export default __webpack_public_path__ + "static/media/uploadqawarning.5be0b27f050b41c9e9682aedd708e0b2.svg";
export { ForwardRef as ReactComponent };